<template>
  <div>
    <mensajeSistema></mensajeSistema>
    <v-row class="pa-3 " v-if="componenteEvento.agregar_submodulo">
      <v-spacer></v-spacer>
      <TableButtonComp normalButton @click="Openmodal(null, 'agregar')" iconBut="fas fa-plus" textButton="Crear perfil" />
      <!-- <btn-comp  iconBut="fa fa-plus"> Crear Perfil</btn-comp> -->
    </v-row>

    <ComundataTablecompVue :whitSearch="true" noResultsText="Sin personal registrado"
      placeholderTextsearch="Buscar personal" :headers="PermisosUsiariosHeaders" :items="Datos" :search="search">
      <template v-slot:estadoValor="{ item }">
        <v-chip v-if="item.estado_perfil == 1" small class="color_activo">
          Activo
        </v-chip>
        <v-chip v-if="item.estado_perfil == 0" small class="mr-2 color_inactivo">
          Inactivo
        </v-chip>
      </template>
      <template v-slot:action_editar="{ item }">
        <TableButtonComp @click="editItem(item)" v-if="componenteEvento.editar_submodulo" editButton
          tooltipText="Editar perfil" />

      </template>
      <template v-slot:action_borrar="{ item }">
        <TableButtonComp @click="deleteConfirm(item)" v-if="componenteEvento.borrar_submodulo"
          :disabled="!item.estado_perfil" tooltipText="Desactivar perfil" icon-but="fas fa-lock" class-color="red" />
      </template>

      <template v-slot:action_config="{ item }">
        <TableButtonComp v-if="componenteEvento.editar_submodulo" :disabled="item.estado_perfil === 0"
          @click="Openmodal(item, 'configurar')" tooltipText="Configurar módulos del perfil" configButton />

      </template>
    </ComundataTablecompVue>


    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="dialogModal" :maxWidth="evento === 'agregar' ? '600' : '400'" :title="formTitle"
        @close-modal="dialogModal = false">
        <template v-slot:body>
          <v-row class="mt-2">
           
            <v-col cols="12" v-if="evento == 'editar'">
              <v-radio-group v-model="editedItem.estado_perfil" label="Estado">
                <v-radio :label="`Activo`" :value="1" color="teal"></v-radio>
                <v-radio :label="`Inactivo`" :value="0" color="error"></v-radio>
              </v-radio-group>
            </v-col>
            <template v-if="evento === 'agregar'">
              <v-col cols="12">
                <!-- {{ licenciaTipo }} -->
                <!-- configuracion {{ createPerfil }} -->
                <v-autocomplete v-model="createPerfil" label="Tipo de licencia" :items="licenciaTipo"
                  @change="CreatePerfilchange(createPerfil)" item-value="id" item-text="desc_tipo_licencia"
                  :rules="[rul.selectReq]" return-object>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" :md="evento === 'agregar'">
                <v-text-field v-model="editedItem.descripcion_perfil" label="Nombre" :rules="[rul.required]"></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="4" lg="4">
                <v-autocomplete :disabled="disabled_modulo_select" v-model="configuracion.id_modulo" :items="modulo"
                  label="Módulo" @change="cargarSubModulo" item-value="id" item-text="nombre_modulo"
                  :rules="[rul.selectReq]">
                </v-autocomplete>
              </v-col> -->


              <v-col cols="12" class="pt-9">
                <v-card outlined>
                  <v-card-text>
                    <v-row dense>
                      <v-col>
                        <label class="font-weight-black black--text">
                          <h3></h3>
                        </label>
                      </v-col>
                      <v-col cols="1" class="d-flex justify-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-checkbox v-model="selectAllmodules" v-bind="attrs" v-on="on" class="ma-0" hide-details />
                          </template>
                          <span>Seleccionar todos los modulos</span>
                        </v-tooltip>
                      </v-col>

                      <v-col cols="1" class="btn_ver d-flex justify-center">
                        <v-tooltip bottom color="#1b1b1b">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" dark x-small>fa-eye</v-icon>
                          </template>
                          <span>VISUALIZAR</span>
                        </v-tooltip>
                      </v-col>

                      <v-col cols="1" class="btn_otro d-flex justify-center">
                        <v-tooltip bottom color="#1b1b1b">
                          <template v-slot:activator="{ on }">
                            <div class="grid">
                              <v-icon dark x-small v-on="on">fa-plus</v-icon>
                            </div>
                          </template>
                          <span>AGREGAR</span>
                        </v-tooltip>
                      </v-col>

                      <v-col cols="1" class="btn_editar d-flex justify-center">
                        <v-tooltip bottom color="#1b1b1b">
                          <template v-slot:activator="{ on }">
                            <v-icon dark x-small v-on="on">fa-pencil-alt</v-icon>
                          </template>
                          <span>EDITAR</span>
                        </v-tooltip>
                      </v-col>

                      <v-col cols="1" class="btn_eliminar d-flex justify-center">
                        <v-tooltip bottom color="#1b1b1b">
                          <template v-slot:activator="{ on }">
                            <v-icon dark x-small v-on="on">fa-trash-alt</v-icon>
                          </template>
                          <span>ELIMINAR</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" v-for=" modulo  in  datosAgrupados " :key="modulo.id">
                        <v-row dense>
                          <v-col cols="12">
                            <v-divider />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <span class="font-weight-bold primary--text">{{ modulo.nombre_modulo }}</span>
                          </v-col>
                        </v-row>
                        <v-row v-for=" item  in  modulo.submodulos " :key="item.id_submodulo">
                          <v-col cols class="py-0">
                            <label class="black--text">{{ item.nombre_submodulo }}</label>
                          </v-col>
                          <v-col cols="1" class="px-0 py-0">
                            <div class="d-flex justify-center">
                              <v-checkbox v-model="confSubModuloAll" :value="item.id" @change="seleccionarTodo(item.id)"
                                class="my-0" color="#8E8E8E" hide-details />
                            </div>
                          </v-col>
                          <v-col cols="1" class="px-0 py-0">
                            <div class="d-flex justify-center">
                              <v-checkbox v-model="confSubModuloV" :value="item.id" @change="seleccionarPermiso(item.id)"
                                class="my-0" color="#388e3c" hide-details />

                            </div>
                          </v-col>
                          <v-col cols="1" class="px-0 py-0">
                            <div class="d-flex justify-center">
                              <v-checkbox v-model="confSubModuloA" :value="item.id" @change="seleccionarPermiso(item.id)"
                                class="my-0" color="#01579b" hide-details />
                            </div>
                          </v-col>
                          <v-col cols="1" class="px-0 py-0">
                            <div class="d-flex justify-center">
                              <v-checkbox v-model="confSubModuloE" :value="item.id" @change="seleccionarPermiso(item.id)"
                                class="my-0" color="#ffbc00" hide-details />
                            </div>
                          </v-col>
                          <v-col cols="1" class="px-0 py-0">
                            <div class="d-flex justify-center">
                              <v-checkbox v-model="confSubModuloD" :value="item.id" @change="seleccionarPermiso(item.id)"
                                class="my-0" color="#e53935" hide-details />
                            </div>
                          </v-col>
                        </v-row>
                        <!-- <v-divider class="mt-3"></v-divider> -->
                      </v-col>

                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>


              <!-- <v-divider></v-divider> -->



            </template>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <TableButtonComp v-if="evento === 'editar'" @click="saveItem" textButton="Guardar cambio" iconBut="fas fa-save"
            normalButton />
          <TableButtonComp normalButton v-if="evento === 'agregar'" :loading="isSavingPerfil" @click="saveItemCompleto"
            textButton="Guardar" iconBut="fas fa-save" />

          <TableButtonComp normalButton classColor="red" @click="dialogModal = false" textButton="Cancelar"
            classButton="ml-2" />
        </template>
      </ComunDialogComp>

    </v-form>

    <ComunDialogComp titleWindow="Desactivar perfil" Deletedialog v-model="dialog_delete"
      @close-modal="dialog_delete = false" @delete-item="deleteItem" @cancel-item="dialog_delete = false">
      <template v-slot:body>
        ¿Está seguro de desactivar este registro?
        <v-chip color="yellow font-weight-black">{{ desc_delete }}</v-chip>
      </template>
    </ComunDialogComp>



    <v-form ref="formPerfilConfig" lazy-validation>
      <ComunDialogComp v-model="dialog_config" maxWidth="600" @close-modal="dialog_config = false"
        title="Configuración de módulos">
        <template v-slot:body>
          <v-row>
            <v-col vols="12" class="d-flex justify-center">
              <v-chip label class="mx-2">
                Perfil :
                {{ configuracion.descripcion_perfil }}
              </v-chip>
              -
              <v-chip label class="mx-2">
                Licencia :
                {{ configuracion.desc_tipo_licencia }}
              </v-chip>

            </v-col>


            <v-col cols="12" class="pt-9">
              <v-card outlined>
                <v-card-text>
                  <v-row dense>
                    <v-col>
                      <label class="font-weight-black black--text">
                        <h3></h3>
                      </label>
                    </v-col>
                    <v-col cols="1" class="d-flex justify-center">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-checkbox v-model="selectAllmodules" v-bind="attrs" v-on="on" class="ma-0" hide-details />
                        </template>
                        <span>Seleccionar todos los modulos</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="1" class="btn_ver d-flex justify-center">
                      <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" dark x-small>fa-eye</v-icon>
                        </template>
                        <span>Visualizar</span>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="1" class="btn_otro d-flex justify-center">
                      <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                          <div class="grid">
                            <v-icon dark x-small v-on="on">fa-plus</v-icon>
                          </div>
                        </template>
                        <span>Agregar</span>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="1" class="btn_editar d-flex justify-center">
                      <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                          <v-icon dark x-small v-on="on">fa-pencil-alt</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="1" class="btn_eliminar d-flex justify-center">
                      <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                          <v-icon dark x-small v-on="on">fa-trash-alt</v-icon>
                        </template>
                        <span>Eliminar</span>
                      </v-tooltip>
                    </v-col>
                    <!-- <v-col cols="12">
                      {{ datosAgrupados }}
                    </v-col> -->




                  </v-row>
                  <v-row>
                    <v-col cols="12" v-for=" modulo  in  datosAgrupados " :key="modulo.id">
                      <v-row dense>
                        <v-col cols="12">
                          <v-divider />
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12">
                          <span class="font-weight-bold primary--text">{{ modulo.nombre_modulo }}</span>
                        </v-col>
                      </v-row>
                      <v-row v-for=" item  in  modulo.submodulos " :key="item.id_submodulo">
                        <v-col cols class="py-0">
                          <label class="black--text">{{ item.nombre_submodulo }}</label>
                        </v-col>
                        <v-col cols="1" class="pa-0 ma-0 d-flex justify-center">
                          <v-checkbox v-model="confSubModuloAll" :value="item.id"
                            @change="toggleTodosSeleccionados(item.id)"
                            :indeterminate="algunosPermisosSeleccionados(item.id)" class="my-0" color="#8E8E8E"
                            hide-details />
                        </v-col>
                        <v-col cols="1" class="pa-0 ma-0 d-flex justify-center">
                          <v-checkbox v-model="confSubModuloV" :value="item.id" @change="seleccionarPermiso(item.id)"
                            class="my-0" color="#388e3c" hide-details />
                        </v-col>
                        <v-col cols="1" class="px-0 py-0">
                          <div class="d-flex justify-center">
                            <v-checkbox v-model="confSubModuloA" :value="item.id" @change="seleccionarPermiso(item.id)"
                              class="my-0" color="#01579b" hide-details />
                          </div>
                        </v-col>
                        <v-col cols="1" class="px-0 py-0">
                          <div class="d-flex justify-center">
                            <v-checkbox v-model="confSubModuloE" :value="item.id" @change="seleccionarPermiso(item.id)"
                              class="my-0" color="#ffbc00" hide-details />
                          </div>
                        </v-col>
                        <v-col cols="1" class="px-0 py-0">
                          <div class="d-flex justify-center">
                            <v-checkbox v-model="confSubModuloD" :value="item.id" @change="seleccionarPermiso(item.id)"
                              class="my-0" color="#e53935" hide-details />
                          </div>
                        </v-col>
                        <!-- <v-divider /> -->
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

            </v-col>

          </v-row>



        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <TableButtonComp normalButton @click="saveConfig" textButton="Guardar" iconBut="fas fa-save" />
          <TableButtonComp normalButton classColor="red" textButton="Cancelar" classButton="ml-2"
            @click="dialog_config = false" />
        </template>
      </ComunDialogComp>

    </v-form>
  </div>
</template>
<style></style>

<script>
import ComundataTablecompVue from "@/components/ComponentsEst/ComundataTablecomp.vue"
import axios from "../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { PermisosUsiariosHeaders } from '../../helpers/headersTable'
import TableButtonComp from '../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../components/ComponentsEst/ComunDialogComp.vue';
// import AutocompleteComp from '../../components/ComponentsEst/AutocompleteComp.vue';
import { validationRules } from '../../helpers/validatorHelpers';

export default {
  name: 'Perfiles',
  components: {
    // BtnComp,
    ComundataTablecompVue,
    ComunDialogComp,
    TableButtonComp,
    // AutocompleteComp
  },
  data: () => ({
    paramComponente: { id_submodulo: 61, id_modulo: 5 },
    datoLogin: sessionStorage,
    dialogModal: false,
    PermisosUsiariosHeaders,
    dialog_config: false,
    selectAllmodules: false,

    dialog_delete: false,
    desc_delete: null,
    id_delete: null,

    evento: null,
    search: "",

    disabled_modulo_select: true,
    // btn loading create prefil
    isSavingPerfil: false,
    createPerfil: [],

    Datos: [],
    modulo: [],
    perfil: [],

    confPerfil: [],
    configuracion: {}, // objeto de configuracion
    confSubModulo: [],
    licenciaTipo: [],
    // Perfil Chequeados
    confSubModuloV: [],
    confSubModuloA: [],
    confSubModuloE: [],
    confSubModuloD: [],
    confSubModuloAll: [],
    datosAgrupados: [],


    titulo: "Perfil",
    formTitle: "",
    editedItem: [],

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
    },
  }),
  computed: {
    validationRules() {
      return validationRules
    },

    isCheckedAll() {
      return Object.values(this.confSubModulo).every(value => value);
    },

    ...mapGetters("login", ["componenteEvento"]),
  },
  mounted() {
    this.loadMain();
  },
  created() {
    this.actualizarParamentro();
  },
  methods: {
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    /**
     __________________________________________
    |          MÉTODO CARGAR INICIAL         */
    async loadMain() {
      try {
        let response = await axios.get(
          "/sistema/perfilColegio/" + this.datoLogin.id_colegio
        );
        this.Datos = response.data;

      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },


    algunosPermisosSeleccionados(idsubomdulo) {

      return ((this.confSubModuloV.includes(idsubomdulo) ||
        this.confSubModuloA.includes(idsubomdulo) ||
        this.confSubModuloE.includes(idsubomdulo) ||
        this.confSubModuloD.includes(idsubomdulo)) && !this.confSubModuloAll.includes(idsubomdulo));
    },

    organizarDatos() {
      this.datosAgrupados = this.organizarPorModulo(this.confSubModulo);
    },

    organizarPorModulo(datos) {
      const datosAgrupados = {};

      datos.forEach((item) => {
        if (!datosAgrupados[item.id_modulo]) {
          datosAgrupados[item.id_modulo] = {
            nombre_modulo: item.nombre_modulo,
            submodulos: []
          };
        }

        datosAgrupados[item.id_modulo].submodulos.push(item);
      });

      return Object.values(datosAgrupados);
    },

    /**
     ______________________________________________
    |          MÉTODO LIMPIAR FORMULARIO         */
    async limpiarForm() {

      this.editedItem = {
        id_usuario: this.datoLogin.id,
        id_colegio: this.datoLogin.id_colegio,
        id: 0,
        descripcion_perfil: "",
        es_webmaster: 0,
        estado: 1,
      };
      this.createPerfil = []
      this.datosAgrupados = []
      this.selectAllmodules = false;
  

      this.resetValidation();
    },
    /**
     ______________________________________________________
    |          MÉTODO RESETEAR CAMPOS AL GUARDAR         */
    resetValidation() {
      this.$refs.formDatos.resetValidation();
    },

    /**
     ______________________________________________________________
    |          MÉTODO ABRIR MODAL CONFIGURACION PERMISOS         */
    async Openmodal(item, event) {
      this.limpiarForm();
      await this.limpiarFormConfig();

      this.evento = event

      // configuracion para el formulario de ingresar nuevo perfil
      if (event == 'agregar') {
        this.formTitle = 'Crear perfil';
        this.dialogModal = true;
        let response = await axios.get(
          "/sistema/perfilColegio/confColegio/" + this.datoLogin.id_colegio);
        this.licenciaTipo = response.data.licenciaTipo;

        // configuracion para el formulario de configurar permisos del perfil
      } else {
        this.formTitle = 'Configuración de módulos';
        this.dialog_config = true;

        this.configuracion.descripcion_perfil = item.descripcion_perfil;
        this.configuracion.desc_tipo_licencia = item.desc_tipo_licencia;
        this.configuracion.id_licencia_tipo = item.id_tipo_licencia;
        this.configuracion.id_colegio = item.id_colegio;
        this.configuracion.id_perfil = item.id;

        this.getAllSubModPerfiles(item.id, item.id_tipo_licencia, item.id_colegio);

        // const response = await axios.get(`/sistema/perfilColegio/modulosTlicencia/${this.configuracion.id_colegio}/${this.configuracion.id_licencia_tipo}`);
        // this.modulo = response.data

      }
    },

    async getModuloTLicencia(id_colegio, id_licencia_tipo) {
      try {
        const response = await axios.get(
          `/sistema/perfilColegio/modulosTlicencia/${id_colegio}/${id_licencia_tipo}`
        );
        this.modulo = response.data;
        // console.log('Respueste de mmodulo', this.modulo);

      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },


    /**
     __________________________________________
    |          MÉTODO CARGAR MODULOS         */

    /**
     _____________________________________________
    |          MÉTODO CARGAR SUBMODULOS         */



    async CreatePerfilchange(item) {
      this.getAllSubModPerfiles(item.id, item.id_licencia_tipo, item.id_colegio)
      this.editedItem.descripcion_perfil = item.desc_tipo_licencia;
    },



    async getAllSubModPerfiles(id_perfil, id_licencia_tipo, id_colegio) {
      try {
        this.configuracion.id_perfil = id_perfil;
        this.configuracion.id_colegio = id_colegio;
        this.configuracion.id_licencia_tipo = id_licencia_tipo;
        console.log('Esta esla configuracion', this.configuracion);
        let response = await axios.post(
          "/sistema/perfilColegio/confSubModuloPerfil",
          this.configuracion
        );

        this.confSubModulo = response.data.subModulo;
        this.confSubModuloV = response.data.confSubModuloV;
        this.confSubModuloA = response.data.confSubModuloA;
        this.confSubModuloE = response.data.confSubModuloE;
        this.confSubModuloD = response.data.confSubModuloD;

        let minLength = Math.min(this.confSubModuloV.length, this.confSubModuloA.length, this.confSubModuloE.length, this.confSubModuloD.length);

        if (minLength === this.confSubModuloV.length.length) {
          this.confSubModuloAll = this.confSubModuloV;
        } else if (minLength === this.confSubModuloA.length.length) {
          this.confSubModuloAll = this.confSubModuloA;
        } else if (minLength === this.confSubModuloE.length.length) {
          this.confSubModuloAll = this.confSubModuloE;
        } else {
          this.confSubModuloAll = this.confSubModuloD;
        }
        
        this.organizarDatos();
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    // async cargarSubModulo(e) {

    //   if (typeof e === "object") {
    //     this.configuracion.id_licencia_tipo = e.id_licencia_tipo
    //   }
    //   this.disabled_modulo_select = false;

    //   if (this.evento == 'agregar') {

    //     this.configuracion.id_colegio = this.datoLogin.id_colegio;

    //     try {
    //       let response = await axios.post(
    //         "/sistema/perfilColegio/confSubModuloPerfil",
    //         this.configuracion
    //       );
    //       this.confSubModulo = response.data.subModulo;
    //     } catch (e) {
    //       (console.error || console.log).call(console, e.stack || e);
    //     }
    //   } else {
    //     try {
    //       let response = await axios.post(
    //         "/sistema/perfilColegio/confSubModuloPerfil",
    //         this.configuracion
    //       );

    //       this.confSubModulo = response.data.subModulo;
    //       this.confSubModuloV = response.data.confSubModuloV;
    //       this.confSubModuloA = response.data.confSubModuloA;
    //       this.confSubModuloE = response.data.confSubModuloE;
    //       this.confSubModuloD = response.data.confSubModuloD;
    //     } catch (e) {
    //       (console.error || console.log).call(console, e.stack || e);
    //     }
    //   }

    // },
    /**
     ___________________________________________
    |          MÉTODO EDITAR REGISTRO         */
    editItem(item) {
      this.limpiarForm();
      this.formTitle = "Editar perfil";
      this.dialogModal = true;
      this.evento = "editar";

      item.id_usuario = this.datoLogin.id;
      this.editedItem = Object.assign({}, item);
    },
    /**
     ________________________________________________
    |          MÉTODO GUARDAR LOS PERFILES         */
    async saveItem() {
      if (this.$refs.formDatos.validate()) {
        try {
          let res = "";
          if (this.evento == "agregar") {
            res = await axios.post("/sistema/perfilColegio", this.editedItem);
          }

          if (this.evento == "editar") {
            res = await axios.put(
              "/sistema/perfilColegio/" + this.editedItem.id,
              this.editedItem
            );
          }

          this.setEnviarMens({
            tipo: `${res.data.messageT}`,
            mensaje: `${res.data.message}`,
            tiempo: null,
          });

          await this.loadMain();
          this.dialogModal = false;
          this.evento = null;

          return res.data.payload.id_perfil

        } catch (e) {
          (console.error || console.log).call(console, e.stack || e);
        }
      }
    },

    /**
     ___________________________________________________________________
    |          MÉTODO GUARDAR CONFIGURACION PERMISOS PERFILES         */
    async saveItemCompleto() {

      // console.log('editedItem',this.editedItem);
      this.isSavingPerfil = true
      // ESTE FLUJO SE CREÓ POR UN REQUERIMIENTO DE REGISTRAR UN PERFIL Y CONFIGURARLO EN EL 
      // MISMO FORMULARIO EVITANDO MODIFICAR LOS FLUJOS ACTUALES Y MODIFICAR CONTROLADORES Y DEMÁS
      let id_new_perfil;

      try {
        if (this.$refs.formDatos.validate()) {
          let res = "";
          if (this.evento == "agregar") {
            res = await axios.post("/sistema/perfilColegio", this.editedItem);
          }

          this.setEnviarMens({
            tipo: `${res.data.messageT}`,
            mensaje: `${res.data.message}`,
            tiempo: null,
          });        

          id_new_perfil = res.data.payload.id_perfil
          this.configuracion.id_perfil = id_new_perfil

          if (this.$refs.formPerfilConfig.validate()) {

              let params = {
                configuracion: this.configuracion,
                subModulo: this.confSubModulo,
                confSubModuloV: this.confSubModuloV,
                confSubModuloA: this.confSubModuloA,
                confSubModuloE: this.confSubModuloE,
                confSubModuloD: this.confSubModuloD,
                id_usuario: this.datoLogin.id,
              };
              await axios.post("/sistema/perfilColegio/saveConfig", params);

              this.setEnviarMens({
                tipo: "S",
                mensaje: `¡Información creada con éxito!`,
                tiempo: null,
              });

              this.dialogModal = false;
              this.evento = null
              await this.limpiarForm();
              await this.limpiarFormConfig();
              await this.loadMain();

          }
        }  

        this.isSavingPerfil = false
      
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /**
     ___________________________________________________________
    |          MÉTODO ABRIR MODAL - CONFIRMAR ACCION          */
    deleteConfirm(items) {
      this.dialog_delete = true;
      this.id_delete = items.id;
      this.desc_delete = `${items.descripcion_perfil} - (${items.id})`;
    },
    /**
     _____________________________________________
    |          MÉTODO BORRAR REGISTROS          */
    async deleteItem() {

      this.dialog_delete = false;
      try {
        let resp = await axios.delete("/sistema/perfilColegio/" + this.id_delete)
        this.loadMain();
        this.dialogModal = false;
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    /**
     _________________________________________________________________
    |          MÉTODO LIMPIAR FORMULARIO DE CONFIGURACIONES         */
    async limpiarFormConfig() {
      this.confSubModulo = [];
      this.selectAllmodules = false;
      this.configuracion = {
        id_perfil: "",
        id_licencia_tipo: "",
        id_modulo: null,
      };
      this.$refs.formPerfilConfig.resetValidation();
    },
    /**
     ___________________________________________________________________
    |          MÉTODO QUE GUARDA LA CONFIGURACION DEL PERFIL          */
    async saveConfig() {
      if (this.$refs.formPerfilConfig.validate()) {

        const arraySubModulos = [];
        this.confSubModulo.forEach(item => {
          arraySubModulos.push(item.id);
        });

        try {

          let params = {
            configuracion: this.configuracion,
            subModulo: this.confSubModulo,
            subModuloArray: arraySubModulos,
            confSubModuloV: this.confSubModuloV,
            confSubModuloA: this.confSubModuloA,
            confSubModuloE: this.confSubModuloE,
            confSubModuloD: this.confSubModuloD,
            id_usuario: +this.datoLogin.id,
          };
          console.log(params);
          const res = await axios.post("/sistema/perfilColegio/saveConfig", params);
          console.log(res);

          let confSubModuloV_result = arraySubModulos.filter(submodulo => !this.confSubModuloV.includes(submodulo));
          let confSubModuloA_result = arraySubModulos.filter(submodulo => !this.confSubModuloA.includes(submodulo));
          let confSubModuloE_result = arraySubModulos.filter(submodulo => !this.confSubModuloE.includes(submodulo));
          let confSubModuloD_result = arraySubModulos.filter(submodulo => !this.confSubModuloD.includes(submodulo));

          let updatePermisos = [
            { condicion: { 'visualizar_submodulo': 0 }, id_submodulo: confSubModuloV_result },
            { condicion: { 'agregar_submodulo': 0 }, id_submodulo: confSubModuloA_result },
            { condicion: { 'editar_submodulo': 0 }, id_submodulo: confSubModuloE_result },
            { condicion: { 'borrar_submodulo': 0 }, id_submodulo: confSubModuloD_result }
          ];

          let paramsValidacionesUsers = {
            configuracion: this.configuracion,
            confSubModuloVAED: updatePermisos
          };

          let response22 = await axios.post("/sistema/perfilColegio/updatePermisos", paramsValidacionesUsers);

          console.log({ response22 });
          this.dialog_config = false;
      

          this.setEnviarMens({
            tipo: "S",
            mensaje: `¡Información editada con éxito!`,
            tiempo: null,
          });

        } catch (e) {
          (console.error || console.log).call(console, e.stack || e);
        }
      }
    },
    /**
     ____________________________________________________________________
    |          MÉTODO SELECCIONAR TODOS LOS CHECKBOX (PERMISOS)        */
    seleccionarTodo(itemID) {
      if (this.confSubModuloAll.includes(itemID)) {
        this.confSubModuloV.push(itemID);
        this.confSubModuloA.push(itemID);
        this.confSubModuloE.push(itemID);
        this.confSubModuloD.push(itemID);
      } else {
        const indexV = this.confSubModuloV.indexOf(itemID);
        const indexA = this.confSubModuloA.indexOf(itemID);
        const indexE = this.confSubModuloE.indexOf(itemID);
        const indexD = this.confSubModuloD.indexOf(itemID);
        if (indexV > -1) this.confSubModuloV.splice(indexV, 1);
        if (indexA > -1) this.confSubModuloA.splice(indexA, 1);
        if (indexE > -1) this.confSubModuloE.splice(indexE, 1);
        if (indexD > -1) this.confSubModuloD.splice(indexD, 1);
      }
      console.log('Configuracion', this.confSubModulo);
    },

    toggleSelectAllModules() {
      if (this.selectAllmodules) {
        this.datosAgrupados.forEach((modulo) => {
          modulo.submodulos.forEach((item) => {
            if (!this.confSubModuloAll.includes(item.id)) {
              this.confSubModuloAll.push(item.id);
              this.confSubModuloV.push(item.id);
              this.confSubModuloA.push(item.id);
              this.confSubModuloE.push(item.id);
              this.confSubModuloD.push(item.id);
            }
          });
        });
      } else {
        this.confSubModuloAll = [];
        this.confSubModuloV = [];
        this.confSubModuloA = [];
        this.confSubModuloE = [];
        this.confSubModuloD = [];
      }
    },

    toggleTodosSeleccionados(itemID) {

      if (!this.confSubModuloV.includes(itemID) &&
        !this.confSubModuloA.includes(itemID) &&
        !this.confSubModuloE.includes(itemID) &&
        !this.confSubModuloD.includes(itemID)) {
        this.confSubModuloV.push(itemID);
        this.confSubModuloA.push(itemID);
        this.confSubModuloE.push(itemID);
        this.confSubModuloD.push(itemID);
      } else if (!this.confSubModuloV.includes(itemID) ||
        !this.confSubModuloA.includes(itemID) ||
        !this.confSubModuloE.includes(itemID) ||
        !this.confSubModuloD.includes(itemID)) {
        const index1 = this.confSubModuloV.indexOf(itemID);
        if (index1 > -1) this.confSubModuloV.splice(index1, 1);

        const index2 = this.confSubModuloA.indexOf(itemID);
        if (index2 > -1) this.confSubModuloA.splice(index2, 1);

        const index3 = this.confSubModuloE.indexOf(itemID);
        if (index3 > -1) this.confSubModuloE.splice(index3, 1);

        const index4 = this.confSubModuloD.indexOf(itemID);
        if (index4 > -1) this.confSubModuloD.splice(index4, 1);

        this.confSubModuloV.push(itemID);
        this.confSubModuloA.push(itemID);
        this.confSubModuloE.push(itemID);
        this.confSubModuloD.push(itemID);

      } else {
        const index1 = this.confSubModuloV.indexOf(itemID);
        if (index1 > -1) this.confSubModuloV.splice(index1, 1);

        const index2 = this.confSubModuloA.indexOf(itemID);
        if (index2 > -1) this.confSubModuloA.splice(index2, 1);

        const index3 = this.confSubModuloE.indexOf(itemID);
        if (index3 > -1) this.confSubModuloE.splice(index3, 1);

        const index4 = this.confSubModuloD.indexOf(itemID);
        if (index4 > -1) this.confSubModuloD.splice(index4, 1);
      }

    },

    /**
     ____________________________________________________________________
    |          MÉTODO SELECCIONAR UN CHECKBOX (UN SOLO PERMISO)        */
    async seleccionarPermiso(itemID) {

      console.log('id submodulo', itemID);
      if (
        this.confSubModuloV.includes(itemID) &&
        this.confSubModuloA.includes(itemID) &&
        this.confSubModuloE.includes(itemID) &&
        this.confSubModuloD.includes(itemID)
      ) {
        console.log('verdaderos');
        this.confSubModuloAll.push(itemID);
      } else {
        const index = this.confSubModuloAll.indexOf(itemID);
        if (index > -1) this.confSubModuloAll.splice(index, 1);
      }
    },
  },

  watch: {
    selectAllmodules() {
      this.toggleSelectAllModules();
    }
  },

};
</script>

